<template>
    <div id="main-layout-middle"
         :style="{ 'background-color': backgroundColor }"
    >
        <Snackbar />
        <FileOptions />

        <ImportMedia initial v-if="!active.id" />

        <div id="wrapper">
            <div id="content">
                <span class="image-before-label">BEFORE</span>

                <div id="canvases">
                    <canvas id="dpx-canvas"></canvas>
                    <canvas id="tiff-export-canvas" class="hide"></canvas>
                    <canvas id="thumbnail-canvas"></canvas>
                    <canvas id="colour-match-canvas"></canvas>
                    <canvas id="develop-raw-canvas" class="hide"></canvas>
                </div>

                <VideoProgress />
                <VideoControls />
                <VideoTimestamp />
            </div>
        </div>

        <Tools />

        <div id="blocks-canvas-container" class="ui-widget-content" style="display: none">
            <select id="curveSelect">
                <option disabled selected value="default">Select curve</option>
            </select>
            <span id="reset-selected-canvases-btn">Reset</span>
        </div>

    </div>
</template>

<script>
import Snackbar from '@/components/app/ui/Snackbar';
import FileOptions from '@/components/app/files/TopOptions';
import VideoProgress from '@/components/app/files/VideoProgress';
import VideoControls from '@/components/app/files/VideoControls';
import VideoTimestamp from '@/components/app/files/VideoTimestamp';
import Tools from '@/components/app/ui/Tools';
import ImportMedia from '@/components/app/buttons/ImportMedia.vue';

import { mapState } from 'vuex';

export default {
    name: 'MainLayoutMiddle',
    components: {
        ImportMedia,
        Snackbar,
        FileOptions,
        VideoProgress,
        VideoControls,
        VideoTimestamp,
        Tools,
    },

    computed: {
        ...mapState('File/Media', ['active']),
        ...mapState('UI', ['backgroundColor', 'startTipsStep']),
    },
};
</script>

<style lang="scss" scoped>
#main-layout-middle {
	/*grid-area: main-layout-middle;*/
	height: 100vh;
	background-color: var(--color-bg-gray);

	display: grid;
	grid-template-columns: 1fr;
	grid-template-rows: var(--status-container-height) 1fr auto var(--tools-container-height);
	grid-template-areas: "top" "main" "IDT-ODT" "tools";

	.import-media-btn {
		display: inline-flex;
		grid-area: main;
		max-width: 200px;
		justify-self: center;
	}
}
</style>
